import { Component, Input } from "@angular/core";

export type FlyoutMenuAction = (item: any, itemIndex: 0) => void;

export interface FlyoutMenuOption {
    name: string;
    action: FlyoutMenuAction;
}

@Component({
    selector: "clare-flyout-menu",
    templateUrl: "./flyout-menu.component.html",
    styleUrls: ["./flyout-menu.component.scss"],
})
export class FlyoutMenuComponent {
    @Input() item;
    @Input() itemIndex: number;
    @Input() options: FlyoutMenuOption[] = [];

    public isOpen = false;

    onOpen() {
        this.isOpen = !this.isOpen;
    }
}
